/**
 *
 * AdministratorBCDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actionCreators from './actions';
import {requestAction} from "domain/typeConstants/action";

class TenantDxGridContainerBase extends React.PureComponent {

    handleRowDoubleClick = (record) => this.props.executeViewAction(record.id);

    handleActionExecuting = (actionName, ids) => {
        switch (actionName) {
            case requestAction.VIEW:
                this.props.executeViewAction(ids[0]);
                break;
            default:
                throw new Error('Executed a unknown action.');
        }
    };

    render() {
        const {component, viewName} = this.props;
        return React.cloneElement(component, {
            viewName,
            onActionExecuting: this.handleActionExecuting,
            onRowDoubleClick: this.handleRowDoubleClick,
        });
    }
}

TenantDxGridContainerBase.propTypes = {
    component: PropTypes.node.isRequired,
    viewName: PropTypes.string.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export const TenantDxGridContainer = connect(null, mapDispatchToProps)(TenantDxGridContainerBase);
